<template>
  <div v-show="is_loading">
    <v-dialog
      v-model="is_loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{ $t('_calculs_en_cours_') }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "LoadingDialog",
  props: {
		is_loading: Boolean,
	},

  // mounted() {
  //   if (this.$refs.content !== undefined) {
  //     this.$nextTick(() => {
  //       let self = this
  //       // Object.getOwnPropertyNames(self);
  //       console.log(self)
  //     });
  //   }
  // },

  methods: {
    isContent() {
      return this.$ref.content !== undefined
    }
  }
}
</script>

<style scoped>

</style>